export function headerSettings() {
  const headerElement = document.querySelector('.header');
  const headerBurgerElement = document.querySelector('.header__burger');
  const headerMenuElement = document.querySelector('.header__bar');
  const menuItems = document.querySelectorAll('.header__menu-link');
  const btnScrollToTop = document.querySelector('.header__logo-wrap');
  const bodyElement = document.body;
  const htmlElement = document.documentElement;
  const CLASS_OPEN = 'open-menu';
  const OVERFLOW_CLASS = 'overflow';

  if (!headerElement || !headerBurgerElement || !headerMenuElement) {
    return;
  }

  function scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  function openMenu() {
    // const addressBarHeight = window.innerHeight - document.documentElement.clientHeight;
    let vh = window.innerHeight * 0.01;

    bodyElement.classList.add(OVERFLOW_CLASS);
    htmlElement.classList.add(OVERFLOW_CLASS);
    headerBurgerElement.classList.add(CLASS_OPEN);
    headerMenuElement.classList.add(CLASS_OPEN);
    headerMenuElement.style.setProperty('--vh', `${vh}px`);
  }

  function closeMenu() {
    bodyElement.classList.remove(OVERFLOW_CLASS);
    htmlElement.classList.remove(OVERFLOW_CLASS);
    headerBurgerElement.classList.remove(CLASS_OPEN);
    headerMenuElement.classList.remove(CLASS_OPEN);
  }

  headerBurgerElement.addEventListener('click', () => {
    if (headerBurgerElement.classList.contains(CLASS_OPEN)) {
      closeMenu();
    } else {
      openMenu();
    }
  });

  if (menuItems.length) {
    menuItems.forEach(el => {
      el.addEventListener('click', closeMenu);
    })
  }

  if (btnScrollToTop) {
    btnScrollToTop.addEventListener('click', scrollToTop);
  }
}


// WEBPACK FOOTER //
// app/scripts/components/header.js